import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RxHamburgerMenu } from "react-icons/rx";

import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { api_url, AXIOS_HEADER } from "../../constants/data";

export default function Sidebar({ toggleHandler }) {
    const navigate = useNavigate();
    const location = useLocation()
    const userState = useSelector(state => state.auth.user);
    const dispatch = useDispatch()

    const [activeMenu, setActiveMenu] = useState('Dashboard');
    const [toggle, setToggle] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const [keyword, setKeyword] = useState(null);
    const [userEf, setUserEf] = useState({});
    
    const handleToggle = () => {
        if (!toggle) {
            setShowSidebar(true);
            setToggle(true);
        } else {
            setToggle(false);
            setTimeout(() => {
                setShowSidebar(false);
            }, 300); // Match animation duration
        }
    };

    useEffect(() => {
        axios.post(`${api_url}/me`, {}, AXIOS_HEADER).then(res => {
            const response = res.data.user

            dispatch({
                type: 'SIGN_IN',
                payload: {
                    user: response
                }
            })

            setUserEf(res.data.data)
        })
        .catch(err => {
            localStorage.removeItem('auth_token')

            navigate('/login')
        })
    }, [])

    const readAllTasks = (e) => {
        e.preventDefault()
        axios.post(`${api_url}/read-all-tasks`, {}, AXIOS_HEADER).then(res => {
            window.location.reload()
        })
    }

    const search = () => {  
        navigate(`/dashboard?q=${keyword}`)
    }


    return (
        <section id="sidebar" className={`${toggle ? 'sidebar_toggle' : ''}`}>
            <div className="sibebar_top">
                <div className="auth_user">
                    <img src={userState?.image} alt="" style={{ width: '32px', borderRadius: '50%' }}  />
                    <p>{userState?.username}</p>
                </div>
                <button className="sidebarnavbtn" onClick={handleToggle}><RxHamburgerMenu /></button>
            </div>

            <div className={`sidebar_menu ${toggle ? 'show_sidebar' : 'hide_sidebar'}`}>
                <div className="search_bar">
                    <input type="text" placeholder="ძებნა" onChange={(e) => setKeyword(e.target.value)} onKeyPress={event => {
                        if (event.key === 'Enter') { search() }
                    }}
                    />
                    <img src="/images/search.png" alt="" />
                </div>
                <div className="menu-items">
                    <div className="menu_item">
                        <Link to={'/dashboard'} className={location.pathname.includes('/task/') || location.pathname.includes('/dashboard') || location.pathname == '/' ? 'active' : ''}>
                            <img src={`/icons/file${location.pathname.includes('/task/') || location.pathname.includes('/dashboard') || location.pathname == '/' ? '-dark' : ''}.png`} alt="" />
                            <p>დავალებები</p>
                        </Link>
                    </div>
                    { userState?.level == 1 && (
                        <div className="menu_item">
                            <Link onClick={readAllTasks} className={location.pathname.includes('/read-all') ? 'active' : ''}>
                                <img src={`/icons/book-search${location.pathname.includes('/read-all') ? '-dark' : ''}.png`} alt="" />
                                <p>ყველას წაკითხვა</p>
                            </Link>
                        </div>
                    )}
                    <div className="menu_item">
                        <Link to={'/new-task'} className={location.pathname.includes('/new-task') ? 'active' : ''}>
                            <img src={`/icons/add${location.pathname.includes('/new-task') ? '-dark' : ''}.png`} alt="" />
                            <p>ახალი დავალება</p>
                        </Link>
                    </div>
                    { userState?.level < 4 ? (
                        <div className="menu_item">
                            <Link to={'/monitoring'} className={location.pathname.includes('/monitoring') ? 'active' : ''}>
                                <img src={`/icons/presentation-chart${location.pathname.includes('/monitoring') ? '-dark' : ''}.png`} alt="" />
                                <p>მონიტორინგი</p>
                            </Link>
                        </div>
                    ) : (
                        <div className="menu_item" style={{ textAlign: 'center', marginTop: '30px', color: '#fff' }}>
                            <p>ეფექტურობის %</p>
                            <h3>{ Math.round((userEf.finished / userEf.total) * 100)}</h3>
                        </div>
                    )}



                    <div className="menu_item logout">
                        <Link to={'/logout'} className={location.pathname.includes('/logout') ? 'active' : ''}>
                            <p>გასვლა</p>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}